import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';
export interface ConfirmDialogData {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  action?: 'Default' | 'Destructive';
}

@Component({
  selector: 'app-mind-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslocoDirective],
  templateUrl: './mind-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  get title(): string {
    return this.data.title ?? 'common.confirmation';
  }

  get confirmText(): string {
    return this.data.confirmText ?? 'common.yes';
  }

  get cancelText(): string {
    return this.data.cancelText ?? 'common.cancel';
  }

  get isDestructiveAction(): boolean {
    return this.data.action === 'Destructive';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
